import React, { useState } from 'react';
// import { EndpointFieldType } from '../../constants/types/componentsTypes/BuilderTypes';
// import { EndpointRow } from '../../constants/types/componentsTypes/BuilderTypes';
import Button from '../General/Button';
import { ButtonTypes } from '../General/Button';
export interface MetricsFilterOptionsProps {
  // options: EndpointRow[];
  values?: { [key: string]: string | number | boolean };
  onChange: (name: string, value: any) => void;
}

export const MetricsFilterOptions: React.FC<MetricsFilterOptionsProps> = ({
  // options,
  values,
  onChange,
}) => {
  const [buttonProps, setButtonProps] = useState<{
    [key: string]: { color: string; bg: string; type: ButtonTypes };
  }>({
    selected: { color: 'white', bg: 'primary', type: 'primary' },
    init: { color: 'warmGray-500', bg: 'warmGray-500', type: 'default' },
  });

  const getBottomComponent = (name: string) => {
    return (
      <div className="flex justify-center items-center p-2 border-t">
        <Button
          color="red-500"
          bg="red-100 hover:bg-red-300 px-8"
          title={'Reset'}
          onClick={() => {
            onChange(name, null);
          }}
        />
      </div>
    );
  };
  const renderFilterOptions = () => {
    return null;
    // return options.map((option, index) => {
    //   const { fieldType, fieldOptions, label, name } = option;

    //   switch (fieldType) {
    //     case EndpointFieldType.Select: {
    //       return (
    //         <div key={name}>
    //           <PopOver
    //             name={name}
    //             label={label}
    //             buttonType={
    //               values?.hasOwnProperty(name)
    //                 ? buttonProps.selected.type
    //                 : buttonProps.init.type
    //             }
    //             bg={
    //               values?.hasOwnProperty(name)
    //                 ? buttonProps.selected.bg
    //                 : buttonProps.init.bg
    //             }
    //             color={
    //               values?.hasOwnProperty(name)
    //                 ? buttonProps.selected.color
    //                 : buttonProps.init.color
    //             }
    //             bottomComponent={getBottomComponent(name)}
    //             padding={0}
    //           >
    //             <div className=" divide-y">
    //               {fieldOptions?.selectOptions?.map((item, i) => (
    //                 <div
    //                   onClick={() => onChange(name, item.value)}
    //                   className={`p-4  cursor-pointer  text-base hover:bg-gray-50 ${
    //                     values?.[name] === item.key ? 'bg-gray-50' : ''
    //                   } `}
    //                   key={item.key + i}
    //                 >
    //                   {item.key}
    //                 </div>
    //               ))}
    //             </div>
    //           </PopOver>
    //         </div>
    //       );
    //     }
    //     case EndpointFieldType.Date:
    //       return (
    //         <PopOver
    //           name={name}
    //           bottomComponent={getBottomComponent(name)}
    //           buttonType={
    //             values?.hasOwnProperty(name)
    //               ? buttonProps.selected.type
    //               : buttonProps.init.type
    //           }
    //           bg={
    //             values?.hasOwnProperty(name)
    //               ? buttonProps.selected.bg
    //               : buttonProps.init.bg
    //           }
    //           color={
    //             values?.hasOwnProperty(name)
    //               ? buttonProps.selected.color
    //               : buttonProps.init.color
    //           }
    //           label={label}
    //         >
    //           <DatePickerInput
    //             name={name}
    //             value={values?.[name]?.toString() || undefined}
    //             onChange={onChange}
    //           />
    //         </PopOver>
    //       );
    //     case EndpointFieldType.DateTime:
    //       return (
    //         <PopOver
    //           name={name}
    //           bottomComponent={getBottomComponent(name)}
    //           buttonType={
    //             values?.hasOwnProperty(name)
    //               ? buttonProps.selected.type
    //               : buttonProps.init.type
    //           }
    //           bg={
    //             values?.hasOwnProperty(name)
    //               ? buttonProps.selected.bg
    //               : buttonProps.init.bg
    //           }
    //           color={
    //             values?.hasOwnProperty(name)
    //               ? buttonProps.selected.color
    //               : buttonProps.init.color
    //           }
    //           label={label}
    //         >
    //           <DatePickerInput
    //             name={name}
    //             showTime={true}
    //             value={values?.[name]?.toString() || undefined}
    //             onChange={onChange}
    //           />
    //         </PopOver>
    //       );

    //     case EndpointFieldType.Text:
    //       return (
    //         <PopOver
    //           name={name}
    //           bottomComponent={getBottomComponent(name)}
    //           buttonType={
    //             values?.hasOwnProperty(name)
    //               ? buttonProps.selected.type
    //               : buttonProps.init.type
    //           }
    //           bg={
    //             values?.hasOwnProperty(name)
    //               ? buttonProps.selected.bg
    //               : buttonProps.init.bg
    //           }
    //           color={
    //             values?.hasOwnProperty(name)
    //               ? buttonProps.selected.color
    //               : buttonProps.init.color
    //           }
    //           label={label}
    //         >
    //           <TextInput
    //             name={name}
    //             value={values?.[name]?.toString() || undefined}
    //             onChange={onChange}
    //           />
    //         </PopOver>
    //       );
    //     case EndpointFieldType.Switch:
    //       return (
    //         <Button
    //           title={label}
    //           type={
    //             values?.[name] === true
    //               ? buttonProps.selected.type
    //               : buttonProps.init.type
    //           }
    //           bg={
    //             values?.[name] === true
    //               ? buttonProps.selected.bg
    //               : buttonProps.init.bg
    //           }
    //           color={
    //             values?.[name] === true
    //               ? buttonProps.selected.color
    //               : buttonProps.init.color
    //           }
    //           onClick={() => onChange(name, !values?.[name])}
    //         />
    //       );
    //   }
    // });
  };
  return (
    <div className="flex justify-start items-center  space-s-2 flex-wrap ">
      {renderFilterOptions()}
      {values && Object.keys(values).length > 0 && (
        <Button
          title={'Reset'}
          type="text"
          bg="red-200"
          color="red-500"
          onClick={() => onChange('', '')}
        />
      )}
    </div>
  );
};
